export function addInstallPromptListener () {
  window.addEventListener('beforeinstallprompt', event => {
    event.preventDefault()
    window.peBeforeInstallPromptEvent = event
  })
}
